import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/bookstore/[username]/components/skeleton/book-grid-skeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/bookstore/[username]/components/skeleton/header-skeleton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/bookstore/[username]/styles.module.scss");
